import { Lookup } from '../constants/lookup.interface';

export interface RoleLookup extends Lookup {
  priority?: number;
}
